import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-conformation',
  templateUrl: './conformation.component.html',
  styleUrls: ['./conformation.component.scss']
})
export class ConformationComponent implements OnInit {
  id;
  type = '';
  action = 'delete';

  constructor(
    public dialogRef: MatDialogRef<ConformationComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
  ) { 
    this.id = data.id;
    this.type = data.type;
    if(data.action){
      this.action = data.action;
    }
    

   }

  ngOnInit(): void {
  }

  onClickYes(){
    if(this.type == 'Company'){
      this._apiService.deleteCompany(this.id).subscribe(res => {
        if (res) {
          console.log(res);
          this.dialogRef.close();
        }
      },
      (error)=>{
        console.log(error);
      });
    }else if(this.type == 'Group'){
      this._apiService.deleteGroup(this.id).subscribe(res => {
        if (res) {
          this.dialogRef.close()
          this._snackBar.open('Group deleted successfully', 'OK', { duration: 3000 })
        }
      },
      (error)=>{
        console.log(error);
      });
    }else if(this.type == 'Poll Result'){
      this._apiService.deletePollExecutionbyID(this.id).subscribe(res => {
        if (res) {
          console.log(res);
          this.dialogRef.close();
        }
      },
      (error)=>{
        console.log(error);
      });
    }else if(this.type == 'Poll'){
      this._apiService.deletePoll(this.id).subscribe(res => {
        if (res) {
          this.dialogRef.close();
          console.log(res);
        }
      },
      (error)=>{
        console.log(error);
      });
    }else if(this.type == 'User'){
      this._apiService.deleteUser(this.id).subscribe(res => {
        if (res) {
          this.dialogRef.close();
          console.log(res);
        }
      },
      (error)=>{
        console.log(error);
      });
    }
    
  }

  onClickCreateClone(){

  }

  onClickNo(){
    this.dialogRef.close();
  }
}
